<template>
  <div class="pricing" v-once>
    <div class="container">
      <el-row type="flex" justify="center">
        <h6>Pricing</h6>
      </el-row>
      <el-row type="flex" justify="center">
        <h3>Simple. Flexible.</h3>
      </el-row>

      <el-row class="plans" type="flex" justify="center" :gutter="40">
        <el-col :md="10">
          <el-card>
            <div>
              <span class="title">Silver</span>
              <span class="price">
                <span class="sign">$</span>
                <span class="amount">14.99</span>
                <span class="cycle">/ month</span>
              </span>
            </div>
            <ul>
              <li><strong>3</strong> Concurrent Pairs</li>
              <li><strong>Unlimited</strong> Sessions and Bags</li>
              <li><strong>VPS</strong> Compatible</li>
              <li><strong>Exchanges</strong> Binance, Bittrex, Poloniex and more</li>
              <li><strong>Upgrade</strong> or cancel anytime</li>
            </ul>
            <router-link to="/buy?silver">
              <el-button type="secondary">Buy Now</el-button>
            </router-link>
          </el-card>
        </el-col>
        <el-col :md="10">
          <el-card>
            <div>
              <span class="title">Gold</span>
              <span class="price">
                <span class="sign">$</span>
                <span class="amount">19.99</span>
                <span class="cycle">/ month</span>
              </span>
            </div>
            <ul>
              <li>
                <strong>10</strong> Concurrent Pairs + $1 for each additional pair
              </li>
              <li>
                <strong>Unlimited</strong> Sessions and Bags
              </li>
              <li>
                <strong>VPS</strong> Compatible
              </li>
              <li>
                <strong>Exchanges</strong> Binance, Bittrex, Poloniex and more
              </li>
              <li>
                <strong>Upgrade</strong> or cancel anytime
              </li>
            </ul>
            <router-link to="/buy">
              <el-button type="primary">Buy Now</el-button>
            </router-link>
          </el-card>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Pricing'
}
</script>

<style lang="scss">
.pricing {
  padding: 80px 10px;
  text-align: center;

  h3, h6 {
    text-align: center;
  }

  h3 {
    font-size: 22px;
    font-weight: 400;
  }

  h6 {
    text-transform: uppercase;
    font-weight: 600;
    font-size: 16px;
    opacity: 0.5;
    margin-bottom: 4px;
  }

  .plans {
    margin-top: 40px;
  }

  .el-card {
    p {
      margin-bottom: 0;
    }

    ul {
      text-align: left;
      list-style-type: none;
      margin: 0;
      padding: 0;
      margin-top: 20px;
      li {
        margin-top: 12px;
      }
    }

    .el-button {
      margin-top: 30px;
      width: 100%;
      text-transform: uppercase;
      font-weight: 500;
    }
    .el-button--primary {
      font-weight: 700;
    }
  }

  span.title {
    text-transform: uppercase;
    font-weight: bold;
    color: #aaa;
    font-size: 13px;
  }

  span.price {
    display: block;
    position: relative;
    padding-bottom: 0px;

    span.sign {
      display: inline-block;
      transform: translate(0, -28px);
      font-weight: 600;
      font-size: 20px;
    }

    span.amount {
      font-weight: 300;
      font-size: 60px;
    }

    span.time {
      font-weight: 600;
      font-size: 14px;
    }
  }
}
</style>
